import commandAgentStates from "./commandAgentStates";

const agentStates = {
    0: {
        id: 0,
        code: "unavailable",
        label: "Non connecté",
        display: false,
        cmd_state: commandAgentStates.disconnect,
    },
    1: {
        id: 1,
        code: "available",
        label: "Disponible",
        display: true,
        cmd_state: commandAgentStates.connect
    },
    2: {
        id: 2,
        code: "busy",
        label: "Occupé",
        display: false,
        cmd_state: commandAgentStates.administrative_pause
    },
    3: {
        id: 3,
        code: "disconnected",
        label: "Déconnecté",
        display: false,
        cmd_state: commandAgentStates.disconnect
    },
    4: {
        id: 4,
        code: "wrap_up",
        label: "WrapUp",
    },
    5: {
        id: 5,
        code: "receiving_call",
        label: "Reçoit un appel",
        display: false,
        cmd_state: commandAgentStates.administrative_pause
    },
    6: {
        id: 6,
        code: "on_acd_call",
        label: "OnAcdCall",
    },
    7: {
        id: 7,
        code: "personal_pause",
        label: "En pause (perso)",
        display: true,
        cmd_state: commandAgentStates.personnal_pause
    },
    8: {
        id: 8,
        code: "working_pause",
        label: "En pause (travail)",
        display: false,
        cmd_state: commandAgentStates.administrative_pause
    },
    9: {
        id: 9,
        code: "reserved_for_automate",
        label: "Automate",
    },
    10: {
        id: 10,
        code: "on_automate_call",
        label: "Campagne",
    },
    11: {
        id: 11,
        code: "automate_wrap_up",
        label: "Post-traitement",
    },
    12: {
        id: 12,
        code: "reserved_for_mail",
        label: "E-mail",
    },
    13: {
        id: 13,
        code: "reserved_for_task",
        label: "Tache",
    },
    14: {
        id: 14,
        code: "reserved_for_chat",
        label: "Chat",
    },
    15: {
        id: 15,
        code: "mail",
        label: "E-mail",
    },
    16: {
        id: 16,
        code: "task",
        label: "Task",
    },
    17: {
        id: 17,
        code: "chat",
        label: "Chat",
        display: false,
    },
    18: {
        id: 18,
        code: "reserved_for_callback",
        label: "ReservedForCallback",
    },
    19: {
        id: 19,
        code: "callback",
        label: "Callback",
    },
    20: {
        id: 20,
        code: "reserved_for_web_callback",
        label: "ReservedForWebCallback",
    },
    21: {
        id: 21,
        code: "web_callback",
        label: "WebCallback",
    },
    22: {
        id: 22,
        code: "reserved_for_voicemail",
        label: "ReservedForVoicemail",
    },
    23: {
        id: 23,
        code: "voicemail",
        label: "Voicemail",
    },
    24: {
        id: 24,
        code: "reserved_for_external",
        label: "ReservedForExternal",
    },
    25: {
        id: 25,
        code: "external",
        label: "External",
    },
};

export default agentStates;